import * as React from 'react';
import { useLocalizedSanityNewsBondsByUrlIdWithoutInvalid } from '../../../../../../../../../../../../../../sanity/queries/news/byId/hooks/bonds/hooks';
import {
  NewsBondsContainer,
  NewsBondsMapper,
  NewsBondsTitle,
} from './components';
import { BondInvalidSAccIdsProvider } from '../../../../../../../../../../../../../../sanity';

const NewsBondsInner = () => {
  const {
    data,
  } = useLocalizedSanityNewsBondsByUrlIdWithoutInvalid();
  if (data == null || data.length === 0) {
    return null;
  }
  return (
    <NewsBondsContainer>
      <NewsBondsTitle />
      <NewsBondsMapper />
    </NewsBondsContainer>
  );
};

export const NewsBonds = () => (
  <BondInvalidSAccIdsProvider>
    <NewsBondsInner />
  </BondInvalidSAccIdsProvider>
);
